/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import Header from "../../Layout/Header";
import Footer from "../../Layout/Footer";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { GoogleMap, MarkerF } from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "500px",
};

const Doctor = () => {
  const [Position, setPosition] = useState([]);
  const [Center, setCenter] = useState({ lat: 0, lng: 0 });
  const data = useSelector((state) => state.AllDoctorApi);
  const location = useLocation();

  // pagination code
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentData = data.slice(startIndex, endIndex);
  const totalPages = Math.ceil(data.length / itemsPerPage);
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  console.log(currentData, "currentData");

  // Function to handle previous page button click
  const handlePreviousPage = () => {
    if (currentPage > 1) {
      handlePageChange(currentPage - 1);
    }
  };
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      handlePageChange(currentPage + 1);
    }
  };
  const searchdata = location.state;

  useEffect(() => {
    if (searchdata !== null) {
      setPosition(
        searchdata.map((e) => {
          return {
            lat: Number(e.latitude),
            lng: Number(e.longitude),
          };
        })
      );
    } else {
      setPosition(
        data.map((marker) => {
          return {
            lat: parseFloat(marker.latitude),
            lng: parseFloat(marker.longitude),
          };
        })
      );
    }
    //   setPosition(newMarkers);
    // });
  }, [data, searchdata]);

  useEffect(() => {
    navigator.geolocation.getCurrentPosition((position) => {
      setCenter({
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      });
    });
  }, []);

  console.log(searchdata, "data");

  const rating = currentData.map((e) => e.averageRating);

  const elements = [];

  for (let i = 1; i <= rating; i++) {
    elements.push(<i class="icon_star voted"></i>);
  }

  const markerOptions = [
    {
      color: "yellow",
    },
    {
      color: "green",
    },
    {
      color: "blue",
    },
  ];

  return (
    <>
      <Header />
      <div id="page">
        <aside class="col-lg-12" id="sidebar">
          {Position.length > 0 ? (
            <div className="" style={{}}>
              <GoogleMap
                mapContainerStyle={containerStyle}
                center={{ lat: Center.lat, lng: Center.lng }}
                zoom={1.5}
                options={{
                  zoomControl: true,
                  streetViewControl: false,
                  mapTypeControl: false,
                  fullscreenControl: false,
                }}
              >
                {data?.map((e, index) => {
                  return (
                    <MarkerF
                      key={index}
                      position={{
                        lat: Number(e.latitude),
                    lng: Number(e.longitude),
                      }}
                      icon={
                        e.type === "dentist"
                          ? {
                              url: `https://maps.google.com/mapfiles/ms/icons/${markerOptions[1].color}-dot.png`,
                            }
                            : e.type === 'doctor'? {
                            url: `https://maps.google.com/mapfiles/ms/icons/${markerOptions[0].color}-dot.png`,
                          }
                          : e.type === 'hypnotherapist'? {
                            url: `https://maps.google.com/mapfiles/ms/icons/${markerOptions[2].color}-dot.png`,
                          }:null}
                    />
                  );
                })}
                {/* <MarkerF
                      // key={index}
                        position={{
                          lat: Position[0]?.lat,
                          lng: Position[0]?.lng,
                        }}
                      /> */}
              </GoogleMap>
            </div>
          ) : null}
        </aside>
        <div class="container margin_60_35">
          {searchdata?.length == 0 ? (
            <div id="results" className="mb-5 bg-theme">
              <div class="container">
                <div class="row">
                  <div class="col-md-12 text-center ">
                    <h4>
                      <strong>No Results Found</strong>
                    </h4>
                  </div>
                </div>
                {/* <!-- /row --> */}
              </div>
              {/* <!-- /container --> */}
            </div>
          ) : (
            <div id="results" className="mb-5 bg-theme">
              <div class="container">
                <div class="row">
                  <div class="col-md-12 text-center ">
                    <h4>
                      <strong>
                        Showing {searchdata !== null ? searchdata.length : null}{" "}
                        {searchdata === null ? data?.length : null} Results
                      </strong>
                    </h4>
                  </div>
                </div>
                {/* <!-- /row --> */}
              </div>
              {/* <!-- /container --> */}
            </div>
          )}
          {/* <!-- /results --> */}

          <div class="row justify-content-center">
            <div class="col-lg-8">
              {searchdata !== null ? (
                <>
                  {searchdata?.map((e) => (
                    <Link to={"/details?id=" + e?.id}>
                      <div class="strip_list ">
                        <figure>
                          <img src={e?.image} alt="not found" />
                        </figure>
                        <small>{e?.type}</small>
                        <h3>
                          {e?.fname} {e?.lname}
                        </h3>

                        <small>
                          {e?.street_address} | {e?.city} | {e?.country}
                        </small>
                        <span class="rating">
                          <i class="icon_star voted"></i>
                          <i class="icon_star voted"></i>
                          <i class="icon_star voted"></i>
                          <i class="icon_star"></i>
                          <i class="icon_star"></i> <small>(145)</small>
                        </span>
                        <a
                          href="badges.html"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Badge Level"
                          class="badge_list_1"
                        >
                          <img
                            src="img/badges/badge_4.svg"
                            width="15"
                            height="15"
                            alt=""
                          />
                        </a>
                      </div>
                    </Link>
                  ))}
                </>
              ) : null}

              {searchdata === null ? (
                <>
                  {currentData?.map((e) => (
                    <Link to={"/details?id=" + e?.id}>
                      <div class="strip_list ">
                        <figure>
                          <img src={e?.image} alt="not found" />
                        </figure>
                        <small>{e?.type}</small>
                        <h3>
                          {e?.fname} {e?.lname}
                        </h3>
                        <small>
                          {e?.street_address} | {e?.city} | {e?.country}
                        </small>
                        {/* <span class="rating">
              {rating=== 0 ?
              <i class="icon_star"></i> :
            elements}<small>({rating})</small>
            </span> */}
                        <a
                          href="badges.html"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Badge Level"
                          class="badge_list_1"
                        >
                          <img
                            src="img/badges/badge_4.svg"
                            width="15"
                            height="15"
                            alt=""
                          />
                        </a>
                      </div>
                    </Link>
                  ))}
                </>
              ) : null}

              {/* Render pagination controls */}
              <nav aria-label="Page navigation example">
                <ul class="pagination justify-content-center pagination-lg">
                  <li class="page-item ">
                    <span
                      class="page-link"
                      href="#"
                      tabindex="-1"
                      disabled={currentPage === 1}
                      onClick={handlePreviousPage}
                    >
                      Previous
                    </span>
                  </li>
                  {Array.from({ length: totalPages }).map((_, index) => (
                    <li
                      key={index}
                      onClick={() => handlePageChange(index + 1)}
                      className={
                        currentPage === index + 1
                          ? "active page-item"
                          : "page-item"
                      }
                    >
                      <span class="page-link">{index + 1}</span>
                    </li>
                  ))}

                  <li
                    class="page-item"
                    disabled={currentPage === totalPages}
                    onClick={handleNextPage}
                  >
                    <span class="page-link" href="#">
                      Next
                    </span>
                  </li>
                </ul>
              </nav>
            </div>
            {/* <!-- /col --> */}

            {/* <!-- /aside --> */}
          </div>
          {/* <!-- /row --> */}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Doctor;
